import React, { Component } from "react"
import "./index.css"
import SocialIcons from "../../SocialIcons"

class HeroSection extends Component {
  render() {
    return (
      <section id="home-hero-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12 p-0">
              <SocialIcons />
            </div>
          </div>

          <div className="row">
            <div className="col-lg-7 col-md-7 col-sm-6"></div>
            <div className="col-lg-4 col-md-5 col-sm-6 home-hero-time-col">
              <div className="home-hero-time-wrapper">
                <div className="row">
                  <div className="col-2 text-white text-center mt-auto">
                    <h1>!</h1>
                  </div>
                  <div className="col-10 text-white home-hero-time-text">
                    <p>
                      Am 13.12.19 beginnt die Show ausnahmsweise um{" "}
                      <strong>19:15 UHR</strong>
                    </p>
                  </div>
                </div>
              </div>

              <h2>Ab Februar 2020</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-12 text-center mt-auto home-hero-btn-group">
              <button className="btn die-show-btn">DIE SHOW</button>
              <button className="btn tickets-btn">TICKETS</button>
            </div>
          </div>
        </div>
      </section>
    )
  }
}

export default HeroSection
